export const detailsStyle: string =
  'color:#7f7f7f;background-color:#F7F8FC;padding:14px 16px;border-radius:8px;margin-block:16px;';

export const summaryStyle = 'margin-bottom: 8px;';

export function formatThoughtMsg(text: string, addThinkWrapper = false): string {
  const formatedText = text
    .replace(
      '<think>',
      `<details style="${detailsStyle}" open> <summary style="${summaryStyle}"> 思考过程 </summary>`,
    )
    .replace('</think>', `</details>`)
    .replace(
      '<summary> Thinking... </summary>',
      '<summary style="${summaryStyle}"> 思考过程 </summary>',
    );

  if (addThinkWrapper) {
    return `<details style="${detailsStyle}" open> <summary style="${summaryStyle}"> 思考过程 </summary> ${formatedText}</details>`;
  }
  return formatedText;
}
